import { settings } from "../../../settings";
import { newsEventApi } from "../api";

// Unsubscribes from financial calendar events, then shows the shared
// confirmation page. Matches UseDeleteUnsubscribe on the index page.
export const UseDeleteNewsEventSubscription = () => {
  const deleteSubscription = async () => {
    await newsEventApi.remove(settings.listing).catch(() => {
      console.log("Error: deleteNewsEventSubscription");
    });

    settings.history.push({
      pathname: "/unsubscribe",
      search: `?lang=${settings.lang}`,
    });
  };

  if (settings.listing) {
    deleteSubscription();
  }
};
